// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import UndoIcon from "@mui/icons-material/Undo";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function UnapproveOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleUnapprove = () => {
        console.log("handleUnapprove");
        // dispatchData(changeOwed({unapproveState: true, owedNewStatus: 'Unapproved'}));
        dispatchData(changeWorkIssuance({newStatus:  '2040', updateCdpStatus: true}));
        onMenuClose();
    };

    return (

        <Box>
            {(
                    rowCdpStatus !== "2040" && rowCdpStatus !== "2359" &&  rowCdpStatus !== "4553"
                ) &&
                <MenuItem onClick={handleUnapprove}>
                    <ListItemIcon>
                        <UndoIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Unapprove</ListItemText>
                </MenuItem>

            }
        </Box>

    )

}
